export default __webpack_public_path__ + "static/media/griswoldHeadshot.92e920ec.webp";